import {NoteList} from "./components/NoteList.tsx";

interface NotebookNavigatorProps {
    notebookId: number
}


export const NotebookNavigator = (props: NotebookNavigatorProps) => {

    const {
        notebookId
    } = props


    return (

        <>
            <NoteList notebookId={notebookId}/>
        </>

    )
}
